<template>
  <div class="pageTableUsers">

    <div class="card-diagram-info d-flex justify-content-between mr-n15px mb-4  flex-sm-row">
      <h2 class="">Komunikaty</h2>
      <div class="wrapper-btn">

<!--        <b-button variant="primary"-->
<!--                  class="custom px-3 px-md-3" :to="{ name: elementRoute }">-->
<!--          <span class="icon icon-plus pr-2"></span>-->
<!--          + Dodaj jednostki ID-->
<!--        </b-button>-->

      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <perfect-scrollbar class="scroll-table">
          <b-table
            striped
            :items="elementsFiltered"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            class="custom table-users"
            :tbody-tr-class="rowClass">
            <template slot="top-row" class="sub-header">
              <td :key="key" v-for="(field, key) in fields">
                <template v-if="[0].indexOf(key) !== -1">
                  <div class="d-flex ">
                    <div class="input-group sm custom search ">
                      <input type="text"
                             :placeholder="$t('Wyszukaj')"
                             v-model="filters[field.key]"
                             class="form-control sm custom">
                    </div>
                  </div>
                </template>
              </td>
            </template>

            <template slot="actions" slot-scope="scope">
              <div class="wrap-ico-btn d-flex justify-content-center align-items-center">
                <EditButton :route="elementRoute"
                            :item-id="scope.item.id">
                </EditButton>
                <DeleteButton :item-id="scope.item.id" :return-param="`deleteCompany`">
                </DeleteButton>

              </div>
            </template>
          </b-table>
        </perfect-scrollbar>
      </div>
    </div>
    <b-row>
      <b-pagination v-show="totalRows > perPage"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    class="custom"></b-pagination>

    </b-row>
    <confirmDeleteModal></confirmDeleteModal>
  </div>

</template>

<script>
import EventBus from '@/event-bus'
import confirmDeleteModal from '@/components/Modals/ConfirmDeleteModal'
import { mapActions } from 'vuex'
import standartFilterMixin from '@/mixins/standartFilterMixin'

import EditButton from '@/components/Buttons/EditButton'
import DeleteButton from '@/components/Buttons/DeleteButton'
import ListTableHeader from '@/components/Headers/ListTableHeader'

export default {
  name: 'adminVatRates',
  components: {
    confirmDeleteModal,
    EditButton,
    DeleteButton,
    ListTableHeader
  },
  mixins: [standartFilterMixin],
  data () {
    return {
      elementRoute: 'admin.administration.announcement',
      fields: [
        { key: 'data1', label: 'Data wczytania pliku', sortable: true },
        { key: 'data2', label: 'Data rejestracji zdarzenia', sortable: true },
        { key: 'data3', label: 'Treść komunikatu', sortable: true },
        { key: 'actions', label: 'Operacje' }
      ]
    }
  },
  methods: {
    ...mapActions(['getInvoiceVatRates']),
    rowClass (item, type) {
      if (type === 'row-top') {
        return 'sub-header'
      }
      return ''
    },
    deleteElement (id) {
      let returnParam = `deleteInvoiceVatRate`
      EventBus.$emit(`SHOW_CONFIRM_DELETE_MODAL`, returnParam, id)
    }
  },
  computed: {
    elements () {
      return this.$store.getters.vatRates
    }
  },
  created () {
    this.getInvoiceVatRates()
  }
}
</script>

<style scoped>

</style>
